/**
 *
 *
 *
 *
 */

let isVoiceMode = $state(false);

export function setVoiceMode(enabled: boolean): void {
    isVoiceMode = enabled;
}

export function getIsVoiceMode(): boolean {
    return isVoiceMode;
}

